var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EDF5F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EDF5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9234 27.7443C22.2521 26.3591 21.0785 25.1898 21.0785 22.6862C21.0785 21.1838 22.2814 20.2101 22.6914 18.9224C23.1015 17.6347 23.3387 16.1102 23.5359 15.0012C23.7331 13.8922 23.8114 13.4633 23.9187 12.2817C24.0498 10.807 23.0966 7 18 7C12.9049 7 11.9487 10.807 12.0828 12.2817C12.19 13.4633 12.2688 13.8923 12.4655 15.0012C12.6623 16.1102 12.8972 17.6346 13.307 18.9224C13.7168 20.2102 14.9214 21.1838 14.9214 22.6862C14.9214 25.1898 13.7478 26.359 10.0765 27.7443C6.39192 29.1326 4 30.5016 4 31.4687V36H32V31.4687C32 30.5031 29.6066 29.1341 25.9234 27.7443V27.7443Z",
    fill: "#CEE0D6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.aeb6f3afcac06ca7df3d4c590d1f9100.svg";
export { ForwardRef as ReactComponent };